<script>
    import { BackArrow } from "../../../Components/Common/index.svelte";

    import BillingRulesPhase_1 from "./BillingRules_Phase_1.svelte";
    import BillingRulesPhase_2 from "./BillingRules_Phase_2.svelte";
    import BillingRulesPhase_3 from "./BillingRules_Phase_3.svelte";
    import BillingRulesPhase_4 from "./BillingRules_Phase_4.svelte";
    import BillingRulesPhase_5 from "./BillingRules_Phase_5.svelte";

    export let personalDetails = {};
    export let updatePhase = () => {};

    let billingRulesPhase = 1;
    // let billingRulesPhase = 5;

    const updateBillingRulesPhase = (phase) => {
        billingRulesPhase = phase;
    };
</script>

<div
    class="flex flex-col w-full gap-y-2 items-center justify-center text-gray-600 bg-gradient-to-b from-secondary to-[#fff] p-6 rounded-t-[15px]"
>
    {#if billingRulesPhase != 5}
        <p class="text-[24px] font-bold">
            Welcome {personalDetails.firstName}
        </p>

        <p class="text-[16px]">Let us show you around</p>
    {:else}
        <div class="flex gap-x-4 w-full items-center">
            <BackArrow backFunc={() => updateBillingRulesPhase(1)} />

            <p class="text-[24px] font-bold">Add Billing Rule</p>
        </div>
    {/if}
</div>

{#if billingRulesPhase == 1}
    <BillingRulesPhase_1 {updateBillingRulesPhase} />
{:else if billingRulesPhase == 2}
    <BillingRulesPhase_2 {updateBillingRulesPhase} />
{:else if billingRulesPhase == 3}
    <BillingRulesPhase_3 {updateBillingRulesPhase} />
{:else if billingRulesPhase == 4}
    <BillingRulesPhase_4 {updateBillingRulesPhase} />
{:else if billingRulesPhase == 5}
    <BillingRulesPhase_5 bind:personalDetails {updatePhase} />
{/if}
